import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  DataClassPathSelf9694s3fei65z as DataClassPathSelf,
  DataClassPathPartial2s3bzp98w5uo7 as DataClassPathPartial,
  DataClassPath3joljqmfaqhxf as DataClassPath,
  DataClassPathAccess21fi12r1lk4vq as DataClassPathAccess,
  DataClassPathNotNullyxwowc5mmyv5 as DataClassPathNotNull,
} from './DataClassPath.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  split3d3yeauc4rm2n as split,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  endsWith278181ii8uuo as endsWith,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
  get_serializableProperties2tbouuwr11am9 as get_serializableProperties,
} from './SerializableProperty.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  nullElementzitp7se36veh as nullElement,
  KSerializerKeys3rcxhak3gf5 as KSerializerKey,
} from './SerializationHelpers.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { KSerializerWithDefault194z2ragoko00 as KSerializerWithDefault } from './Defaults.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClassPathSerializerClass;
function DataClassPathSerializer() {
  if (DataClassPathSerializerClass === VOID) {
    class $ {
      constructor(inner) {
        this.b4b_1 = inner;
        this.c4b_1 = PrimitiveSerialDescriptor('com.lightningkite.lightningdb.DataClassPathPartial', STRING_getInstance());
      }
      z3m() {
        return new (DataClassPathSelf())(this.b4b_1);
      }
      az() {
        return this.c4b_1;
      }
      pz(decoder) {
        var value = decoder.h13();
        return this.a3s(value);
      }
      u4q(encoder, value) {
        encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.u4q(encoder, value instanceof DataClassPathPartial() ? value : THROW_CCE());
      }
      a3s(value) {
        var current = null;
        var currentSerializer = this.b4b_1;
        var valueParts = split(value, charArrayOf([_Char___init__impl__6a9atx(46)]));
        var iterator = valueParts.m1();
        var index = 0;
        $l$loop: while (iterator.n1()) {
          var index_0 = index;
          index = index + 1 | 0;
          var part = iterator.o1();
          var name = removeSuffix(part, '?');
          if (name === 'this')
            continue $l$loop;
          var tmp;
          try {
            tmp = Companion_getInstance().w4q(currentSerializer).v3r(name);
          } catch ($p) {
            var tmp_0;
            if ($p instanceof IllegalStateException()) {
              var e = $p;
              throw SerializationException().q10(e.message, e);
            } else {
              throw $p;
            }
          }
          var prop = tmp;
          currentSerializer = prop.j2j();
          var c = current;
          var tmp_1;
          if (c == null) {
            var tmp_2 = new (DataClassPathSelf())(this.b4b_1);
            tmp_1 = new (DataClassPathAccess())(tmp_2, isInterface(prop, SerializableProperty()) ? prop : THROW_CCE());
          } else {
            var tmp_3 = c instanceof DataClassPath() ? c : THROW_CCE();
            tmp_1 = new (DataClassPathAccess())(tmp_3, isInterface(prop, SerializableProperty()) ? prop : THROW_CCE());
          }
          current = tmp_1;
          if (endsWith(part, _Char___init__impl__6a9atx(63)) || (prop.j2j().az().l11() && !(index_0 === get_lastIndex(valueParts)))) {
            current = new (DataClassPathNotNull())(current instanceof DataClassPath() ? current : THROW_CCE());
            var tmp0_elvis_lhs = nullElement(currentSerializer);
            var tmp_4;
            if (tmp0_elvis_lhs == null) {
              throw SerializationException().p10(prop.k20() + ' is not nullable');
            } else {
              tmp_4 = tmp0_elvis_lhs;
            }
            currentSerializer = tmp_4;
          }
        }
        var tmp1_elvis_lhs = current;
        return tmp1_elvis_lhs == null ? new (DataClassPathSelf())(this.b4b_1) : tmp1_elvis_lhs;
      }
    }
    initMetadataForClass($, 'DataClassPathSerializer', VOID, VOID, [KSerializerWithDefault()]);
    DataClassPathSerializerClass = $;
  }
  return DataClassPathSerializerClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.v4q_1 = HashMap().n8();
      }
      w4q(serializer) {
        var tmp0 = this.v4q_1;
        // Inline function 'kotlin.collections.getOrPut' call
        var key = KSerializerKey().r3t(serializer);
        var value = tmp0.p3(key);
        var tmp;
        if (value == null) {
          var answer = new (SerializablePropertyParser())(serializer);
          tmp0.s3(key, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        var tmp_0 = tmp;
        return tmp_0 instanceof SerializablePropertyParser() ? tmp_0 : THROW_CCE();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SerializablePropertyParserClass;
function SerializablePropertyParser() {
  if (SerializablePropertyParserClass === VOID) {
    class $ {
      constructor(serializer) {
        Companion_getInstance();
        this.x4q_1 = serializer;
        var tmp = this;
        // Inline function 'kotlin.run' call
        var tmp0_elvis_lhs = get_serializableProperties(this.x4q_1);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          throw SerializationException().p10(this.x4q_1.az().h10() + ' does not have any serializable properties');
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = tmp_0;
        var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap().fc(capacity);
        var inductionVariable = 0;
        var last = this_0.length;
        while (inductionVariable < last) {
          var element = this_0[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$0 = element.k20();
          destination.s3(tmp$ret$0, element);
        }
        tmp.y4q_1 = destination;
      }
      v3r(key) {
        var tmp0_elvis_lhs = this.y4q_1.p3(key);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException().o4("Could find no property with name '" + key + "' on " + this.x4q_1.az().h10());
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'SerializablePropertyParser');
    SerializablePropertyParserClass = $;
  }
  return SerializablePropertyParserClass;
}
//region block: exports
export {
  DataClassPathSerializer as DataClassPathSerializer1pr4zwqha0dv8,
};
//endregion

//# sourceMappingURL=DataClassPathSerializer.mjs.map
